import { render, staticRenderFns } from "./ModalSubscribe.vue?vue&type=template&id=05a22029&scoped=true"
import script from "./ModalSubscribe.vue?vue&type=script&lang=js"
export * from "./ModalSubscribe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a22029",
  null
  
)

export default component.exports